var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('v-container',{staticClass:"label",attrs:{"fluid":""}},[_vm._v("\n  "+_vm._s(_vm.maintenanceText)+"\n  "),_c('v-icon',{attrs:{"small":""}},[_vm._v("report_problem")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a9b071f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MaintenanceLabel.vue
// module id = e0cv
// module chunks = 1